var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJoinHands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_544",
    "data-name": "Group 544",
    transform: "translate(-131 -846.984)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(131 846.984)",
    fill: "#ff4500",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M9.207-19.5H6.9L3.944-17.528H0v6.9H4.813L7.09-8.549l1.091,1,1.47-1.608.687.632,1.091,1,1.38-1.507,1.085.992,2-2.182-1.091-1-4.135-3.79L7.7-12.7l-.4.311L7-12.8,5.026-15.516l-.274-.379.364-.3Zm2.283,3.849,5.463,5.026H19.72v-6.9H15.755l-.12-.077L12.673-19.5h-1.9L6.1-15.713l1.4,1.92,4.036-3.14.388-.3.6.78-.388.3-.644.5Z",
    transform: "translate(137.134 877.06)",
    fill: "#142f73"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinHands);
export default __webpack_public_path__ + "static/media/join-hands.d064822411a4af5274a8f7760cb938ef.svg";
export { ForwardRef as ReactComponent };